module.exports = __webpack_public_path__ + "static/media/down-arrow.85ead620.svg";